import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

const SECRET_KEY = 'archivar';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private storage = sessionStorage;

  private hash(key: string): string {
    return CryptoJS.SHA256(key, SECRET_KEY).toString();
  }

  public secureStorage = {
    setItem: (key: string, data: any) => {
      const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
      this.storage.setItem(this.hash(key), encrypted);
    },
    getItem: (key: string): any => {
      const encrypted = this.storage.getItem(this.hash(key));
      if (!encrypted) return null;
      try {
        const decrypted = CryptoJS.AES.decrypt(encrypted, SECRET_KEY).toString(CryptoJS.enc.Utf8);
        return JSON.parse(decrypted);
      } catch {
        return null;
      }
    },
    clear: () => {
      this.storage.clear();
    }
  };
}
